<template>
  <div v-html="iconHtml" class="svg-container" />
</template>
<script>
import svgMap from '@/static/js/icon.js'
function recursivelyRemoveFill(el) {
  if (!el) {
    return
  }
  el.removeAttribute('fill');
  [].forEach.call(el.children, child => {
    recursivelyRemoveFill(child)
  })
}

export default {
  props: {
    icon: {
      type: String,
      default: null,
      required: true
    },
    hasFill: {
      type: Boolean,
      default: true
    },
    growByHeight: {
      type: Boolean,
      default: true
    },
    // 是否保持 svg 原样
    isKeep: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconHtml() {
      const { icon } = this
      const curIcon = svgMap[icon]
      if (!curIcon) {
        return ''
      }
      return curIcon
    }
  },
  watch: {
    iconHtml: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          this.iconInit()
        })
      }
    }
  },
  methods: {
    iconInit() {
      if (this.isKeep) {
        return
      }
      const svgElement = this.$el.firstElementChild
      if (svgElement && svgElement.nodeName === 'svg') {
        const svgElement = this.$el.firstElementChild
        // use `viewBox` attribute to get the svg's inherent width and height
        const viewBox = svgElement.getAttribute('viewBox').split(' ').map(n => Number(n))
        const widthToHeight = (viewBox[2] / viewBox[3]).toFixed(2)
        if (this.hasFill) {
          // recursively remove all fill attribute of element and its nested children
          recursivelyRemoveFill(svgElement)
        }
        // set width and height relative to font size
        // if growByHeight is true, height set to 1em else width set to 1em and remaining is calculated based on widthToHeight ratio
        if (this.growByHeight) {
          svgElement.setAttribute('height', '1em')
          svgElement.setAttribute('width', `${widthToHeight}em`)
        } else {
          svgElement.setAttribute('width', '1em')
          svgElement.setAttribute('height', `${1 / widthToHeight}em`)
        }
        svgElement.classList.add('svg-class')
      }
    }
  }
}
</script>

<style scoped>
.svg-container {
    display: inline-flex;
}
</style>
